import glamorous from 'glamorous'

import { groupCSS, hexToRgb } from '../../../helpers/styles'

import { Props } from './SubmitButton'

import * as colours from '../../../styles/colours'
import * as fonts from '../../../styles/typography'
import { easing } from '../../../styles/animation'

const disabled: string[] = [
  '[disabled]',
  ':disabled',
]

export const StyledSubmitButton = glamorous.button<Props>({
  display: 'flex',
  width: '100%',
  height: 60,
  border: 'none',
  borderTop: `1px solid ${colours.mainStroke}`,
  outline: 'none',
  backgroundColor: colours.brandBl,
  color: colours.white,
  fontFamily: fonts.fontMedium,
  fontSize: 20,
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: `background-color 250ms ${easing.easeOut}, color 250ms ${easing.easeOut}`,
  ...groupCSS(disabled, {
    backgroundColor: colours.white,
    color: `rgba(${hexToRgb(colours.basicBlMain)}, 0.5)`,
    cursor: 'default',
  }),
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/SubmitButton/SubmitButton.glamorous.tsx